"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInputStyles = void 0;
var presets_1 = require("../../presets");
var createDefaults_1 = require("../createDefaults");
var createFileInputStyle = (0, createDefaults_1.createDefaultVariantFactory)();
var presets = (0, presets_1.includePresets)(function (styles) { return createFileInputStyle(function () { return ({ wrapper: styles }); }); });
exports.FileInputStyles = __assign(__assign({}, presets), { default: createFileInputStyle(function (theme) { return ({}); }), circle: createFileInputStyle(function (theme) { return ({}); }), pill: createFileInputStyle(function (theme) { return ({}); }) });
